import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import * as c3 from 'c3';

@Component({
  selector: 'app-bar-chart-popup',
  templateUrl: './bar-chart-popup.component.html',
  styleUrls: ['./bar-chart-popup.component.scss']
})
export class BarChartPopupComponent implements OnInit, AfterViewInit {

  @ViewChild('graphDiv', { static: true }) graphDiv: ElementRef;
  colorList = ['#D26999', '#8F82C7', '#82C7C2', '#72A8D5', '#D26999'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.data) {
      this.drawGraph();
    }
  }


  drawGraph() {
    const chart = c3.generate({
      bindto: this.graphDiv.nativeElement,
      // padding: {
      //   top: 0,
      //   right: 10,
      //   bottom: 20
      // },
      data: {
        json: this.data.data,
        keys: {
          x: 'label',
          value: ['val'],
        },
        type: 'bar',
        labels: {
          format: (v) => {
            return v + '%';
          }
        },
        color: (color, d: any) => {
          return this.colorList[d.index];
        }
      },
      legend: {
        show: false
      },
      axis: {
        x: {
          label: {
            text: 'Classification',
            position: 'outer-center'
          },
          type: 'category',
          tick: {
            centered: true,
          },
        },
        y: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          tick: {
            format(val) { return val + '%'; }
          }
        }
      },

      bar: {
        width: {
          ratio: .5
        }
      },
      tooltip: {
        show: false
      }

      // tooltip: {
      //   format: {
      //     title: function (d) { return 'Cost Contribution'; },
      //     value: function (value, ratio, id) {
      //       return String(value);
      //     }
      //   }
      // }

    });

    chart.load({});
  }

}
